export const people =[
    {
        id: 1,
        image:"https://avatars.githubusercontent.com/u/63696529?s=120&v=4",
        name : "Harvy Neson",
        title :"student",
        quote:"I think we've been using Taste Bite for a while now and it's an awesome app.It's very easy to use and you can save recipes in it. I think the best thing about this app is that it has alot of categories,so you are ablee to find the perfect recipe for any occassion. ",
    }
    ,

    {
        id: 2,
        image:"https://th.bing.com/th/id/R.718742d70bb5129db9ac83d699cb6aca?rik=sxpvTvzS8%2f2R%2fA&riu=http%3a%2f%2fweknowyourdreams.com%2fimages%2fwife%2fwife-01.jpg&ehk=ue6Y4Uwkuu2f%2fYjBUVhNlR37HO9tk9CcKRrVAtTjLak%3d&risl=&pid=ImgRaw&r=0",
        name : "Johnson Mwendwa",
        title :"wife",
        quote:"I have a lot of food allergies and i'm always excited to find new recipes that i can cook. Taste Bite has a large collection of recipes with photos, ingredients and instructions."
    }

    ,{
        id: 3,
        image:"https://th.bing.com/th/id/R.c571d0e5d938a891fbe1630635ecc38f?rik=7wiUdBkzBOTtpA&pid=ImgRaw&r=0",
        name : "Colson Walker",
        title :"chef",
        quote:"I have alot of food allergies and allel love this app! I can share my favorite recipes with my friends and family. And it's so easy to use , even my grandmother can do it!rgiesand i'm always excited to fid new recipest that i can cook.Taste Bite has a large collection of recipes with photos, ingredients and instructions. "
    }
]